<template>
  <div id="app">
    <keep-alive :include="cachedViews">
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      // 需要缓存的组件名称列表（组件的 name 属性值）
      cachedViews: ['Main']
    }
  }
}
</script>

<style>
	body{
		margin:0 !important;
	}
:root {
  --primary-color: #409eff;
  --secondary-color: #67c23a;
  --danger-color: #f56c6c;
  --warning-color: #e6a23c;
  --info-color: #909399;
  --light-color: #f5f7fa;
  --dark-color: #1f1f1f;
  --text-color: #303133;
  --text-color-secondary: #606266;
  --border-color: #e4e7ed;
  --bg-color: #ffffff;
  --bg-color-light: #f5f7fa;
}

/* 黑暗主题变量 */
.dark-theme {
  --primary-color: #66b1ff;
  --secondary-color: #85ce61;
  --danger-color: #f78989;
  --warning-color: #ebb563;
  --info-color: #909399;
  --light-color: #303030;
  --dark-color: #1f1f1f;
  --text-color: #e4e7ed;
  --text-color-secondary: #909399;
  --border-color: #404040;
  --bg-color: #2a2a2a;
  --bg-color-light: #303030;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--text-color);
  height: 100vh;
  background-color: var(--bg-color-light);
  transition: all 0.3s ease;
}

/* 滚动条样�?*/
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: var(--bg-color-light);
}

::-webkit-scrollbar-thumb {
  background: var(--border-color);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: var(--info-color);
}

/* 暗黑模式 el-dialog 全局样式 */
.dark-theme .el-dialog {
  background-color: #2a2a2a;
  border-color: #404040;
}

.dark-theme .el-dialog__header {
  border-bottom-color: #404040;
}

.dark-theme .el-dialog__title {
  color: #e4e7ed;
}

.dark-theme .el-dialog__headerbtn .el-dialog__close {
  color: #e4e7ed;
}

.dark-theme .el-dialog__body {
  color: #e4e7ed;
}

.dark-theme .el-dialog__footer {
  border-top-color: #404040;
}

.dark-theme .el-overlay {
  background-color: rgba(0, 0, 0, 0.7);
}

/* 暗黑模式 el-button 样式 */
.dark-theme .el-button--default {
  background-color: #333333;
  border-color: #404040;
  color: #e4e7ed;
}

.dark-theme .el-button--default:hover {
  background-color: #404040;
  border-color: #505050;
}

.dark-theme .el-button--primary {
  background-color: #409EFF;
  border-color: #409EFF;
  color: #fff;
}

.dark-theme .el-button--danger {
  background-color: #f56c6c;
  border-color: #f56c6c;
  color: #fff;
}

/* 暗黑模式 el-form 样式 */
.dark-theme .el-form-item__label {
  color: #e4e7ed;
}

/* 暗黑模式 el-input 样式 */
.dark-theme .el-input__inner {
  background-color: #333333;
  border-color: #404040;
  color: #e4e7ed;
}

.dark-theme .el-input__inner::placeholder {
  color: #909399;
}

/* 暗黑模式 el-select 样式 */
.dark-theme .el-select .el-input__inner {
  background-color: #333333;
}

.dark-theme .el-select-dropdown {
  background-color: #333333;
  border-color: #404040;
}

.dark-theme .el-select-dropdown__item {
  color: #e4e7ed;
}

.dark-theme .el-select-dropdown__item:hover {
  background-color: #404040;
}

/* 暗黑模式 el-date-picker 样式 */
.dark-theme .el-picker-panel {
  background-color: #333333;
  border-color: #404040;
}

.dark-theme .el-date-table th {
  color: #e4e7ed;
}

.dark-theme .el-date-table td .el-date-table-cell {
  color: #e4e7ed;
}

.dark-theme .el-date-table td.available:hover {
  background-color: #404040;
}

/* 暗黑模式 el-radio 样式 */
.dark-theme .el-radio__label {
  color: #e4e7ed;
}

/* 暗黑模式 el-divider 样式 */
.dark-theme .el-divider {
  background-color: #404040;
}

.dark-theme .el-divider__text {
  background-color: #2a2a2a;
  color: #409EFF;
}

/* 暗黑模式 el-card 样式 */
.dark-theme .el-card {
  background-color: #2a2a2a;
  border-color: #404040;
}

.dark-theme .el-card__header {
  border-bottom-color: #404040;
}

.dark-theme .el-card__body {
  color: #e4e7ed;
}

/* 暗黑模式 el-table 样式 */
.dark-theme .el-table {
  background-color: #2a2a2a;
  color: #e4e7ed;
}

.dark-theme .el-table th {
  background-color: #333333;
  color: #e4e7ed;
  border-color: #404040;
}

.dark-theme .el-table td {
  border-color: #404040;
}

.dark-theme .el-table__body tr:hover > td {
  background-color: #404040;
}

.dark-theme .el-table__body tr.current-row td {
  background-color: #4a6cf7;
  color: #fff;
}

.dark-theme .el-table__body tr.el-table__row--striped td {
  background-color: #333333;
}

/* 暗黑模式 el-pagination 样式 */
.dark-theme .el-pagination {
  color: #e4e7ed;
}

.dark-theme .el-pager li {
  background-color: #333333;
  color: #e4e7ed;
}

.dark-theme .el-pager li.active {
  background-color: #409EFF;
  color: #fff;
}

/* 暗黑模式 el-menu 样式 */
.dark-theme .el-menu {
  background-color: #2a2a2a;
  border-color: #404040;
}

.dark-theme .el-menu-item {
  color: #e4e7ed;
}

.dark-theme .el-menu-item:hover {
  background-color: #404040;
}

.dark-theme .el-menu-item.is-active {
  background-color: #409EFF;
  color: #fff;
}

/* 暗黑模式 el-dropdown 样式 */
.dark-theme .el-dropdown-menu {
  background-color: #333333;
  border-color: #404040;
}

.dark-theme .el-dropdown-menu__item {
  color: #e4e7ed;
}

.dark-theme .el-dropdown-menu__item:hover {
  background-color: #404040;
}

/* 暗黑模式 el-message-box 样式 */
.dark-theme .el-message-box {
  background-color: #2a2a2a;
  border-color: #404040;
}

.dark-theme .el-message-box__title {
  color: #e4e7ed;
}

.dark-theme .el-message-box__content {
  color: #e4e7ed;
}

/* 暗黑模式 el-tooltip 样式 */
.dark-theme .el-tooltip__popper {
  background-color: #333333;
  border-color: #404040;
}

.dark-theme .el-tooltip__popper .popper__arrow::after {
  border-color: #333333;
}

/* 暗黑模式 el-loading 样式 */
.dark-theme .el-loading-mask {
  background-color: rgba(42, 42, 42, 0.8);
}

.dark-theme .el-loading-spinner {
  color: #409EFF;
}

.dark-theme .el-loading-spinner .circular {
  stroke: #409EFF;
}

.dark-theme .el-loading-spinner .path {
  stroke: #409EFF;
}

.dark-theme .el-loading-text {
  color: #e4e7ed;
}

.dark-theme .el-loading-spinner .el-icon-loading {
  color: #409EFF;
}
</style>
